import { Download, ImagePlus } from 'lucide-react';
import { LiksDialog } from '../LiksDialog/LiksDialog';
import { LiksChatMessageImageMetaBadges } from './LiksChatMessageImageMetaBadges';
import { LiksChatMessageImageActionButton } from './LiksChatMessageImageActionButton';
import './LiksChatMessageImagePreviewModal.css';

export type LiksChatMessageImagePreviewModalProps = {
  isOpen: boolean;
  imageUrl: string;
  alt: string;
  title?: string | null;
  imageFormat?: string | null;
  imageAspectRatio?: string | null;
  downloadLabel?: string;
  onDownload?: () => void;
  saveToGalleryLabel?: string;
  onSaveToGallery?: () => void;
  isSaveToGalleryPending?: boolean;
  closeLabel: string;
  onClose: () => void;
};

export function LiksChatMessageImagePreviewModal({
  isOpen,
  imageUrl,
  alt,
  title,
  imageFormat,
  imageAspectRatio,
  downloadLabel,
  onDownload,
  saveToGalleryLabel,
  onSaveToGallery,
  isSaveToGalleryPending = false,
  closeLabel,
  onClose,
}: LiksChatMessageImagePreviewModalProps) {
  const heading = title?.trim() || alt;
  const showActions =
    (onDownload != null && downloadLabel != null) ||
    (onSaveToGallery != null && saveToGalleryLabel != null);

  return (
    <LiksDialog
      isOpen={isOpen}
      onClose={onClose}
      size="full"
      className="liks-chat-message__image-preview"
      bodyClassName="liks-chat-message__image-preview-body"
      closeLabel={closeLabel}
      title={
        <>
          <span className="liks-chat-message__image-preview-title-text">
            {heading}
          </span>
          <LiksChatMessageImageMetaBadges
            imageFormat={imageFormat}
            imageAspectRatio={imageAspectRatio}
          />
        </>
      }
    >
      <div className="liks-chat-message__image-preview-media">
        <img
          className="liks-chat-message__image-preview-img"
          src={imageUrl}
          alt={alt}
        />
        {showActions && (
          <div className="liks-chat-message__image-actions">
            {onDownload && downloadLabel && (
              <LiksChatMessageImageActionButton
                label={downloadLabel}
                onClick={onDownload}
              >
                <Download
                  className="liks-chat-message__image-action-icon"
                  strokeWidth={2}
                  aria-hidden
                />
              </LiksChatMessageImageActionButton>
            )}
            {onSaveToGallery && saveToGalleryLabel && (
              <LiksChatMessageImageActionButton
                label={saveToGalleryLabel}
                disabled={isSaveToGalleryPending}
                onClick={onSaveToGallery}
              >
                <ImagePlus
                  className="liks-chat-message__image-action-icon"
                  strokeWidth={2}
                  aria-hidden
                />
              </LiksChatMessageImageActionButton>
            )}
          </div>
        )}
      </div>
    </LiksDialog>
  );
}
